jQuery(function($){
  load_articles();
  $(window).on("resize scroll",function(){
    load_articles();
  });
});

var canBeLoaded = true,
    bottomOffset = 2000;

function load_articles() {
  var data = {
    'action'    : 'get_articles',
    'query'     : infinity_scroll.posts,
    'page'      : infinity_scroll.current_page,
    'page_type' : infinity_scroll.page_type
  };

  if( $(document).scrollTop() > ( $(document).height() - bottomOffset ) && canBeLoaded == true ) {
    $.ajax({
      url         : infinity_scroll.ajaxurl,
      data        : data,
      type        : 'POST',
      beforeSend  : function( xhr ) {
        canBeLoaded = false;
      },
      success     : function(data) {
        if( data ) {
          $('.article__items').append( data );
          canBeLoaded = true;
          infinity_scroll.current_page++;
        }
      },
      complete    : function () {
        setCardBackgroundImage();
      }
    });
  }
}

function setCardBackgroundImage() {
  $('.card__image--as-background').each(function () {
    let imageUrl = $(this).find('img').attr('src');
    $(this).css('background-image', 'url('+ imageUrl + ')' );
  });
}
